'use strict';

export const USER_PRIORITIES_COLLECTION = 'user-priorities';



// WEBPACK FOOTER //
// ./src/js/priorities/domain/config.js